export const destination = [ 37.7749, -122.4194 ]
// San Francisco coordinates
